import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoRescueSheets from "../servicios/InfoRescueSheets";
const Footer = lazy(() => import('../footer/Footer'));
function RescueSheets() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai nos preocupamos por tu seguridad. Revisa las hojas de rescate de tu Hyundai"
        />
        <meta name="keywords" content="manual Hyundai" />
        <title>Hoja de rescate | Hyundai</title>
      </Helmet>
      <Menu />
      <InfoRescueSheets />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default RescueSheets;